var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.TitleBar,{attrs:{"title":"Buzón de Sugerencias","icon":""}}),(!_setup.isLoading)?_c('div',{staticClass:"tw-container-general tw-my-5"},[_c(_setup.Mailbox)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }